function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

const elements = document.querySelectorAll('.animate-box-more');

function animateOnScroll() {
  const windowHeight = window.innerHeight;

  elements.forEach(el => {
    const rect = el.getBoundingClientRect();
    const start = windowHeight; 
    const end = -rect.height;  
    const progress = (start - rect.top) / (start - end);
    const clamped = Math.max(0, Math.min(1, progress));
    const translateY = 100 + (clamped * (-220));
    el.style.transform = `translateY(${translateY}px)`;
  });
}

window.addEventListener('scroll', animateOnScroll);
animateOnScroll();


(() => {
  'use strict';

  // ── Config ────────────────────────────────────────────
  const ROOT_MARGIN = '200px 0px'; // viewport ma aavta pehla j preload start thay (smoother UX)
  const SELECTOR = 'img[data-src], video[data-src], video source[data-src]';

  // ── Reveal logic (image) ─────────────────────────────
  const revealImage = (img) => {
    const picture = img.closest('picture');
    if (picture) {
      picture.querySelectorAll('source[data-srcset]').forEach((source) => {
        source.srcset = source.dataset.srcset;
        delete source.dataset.srcset;
      });
    }
    if (img.dataset.src) {
      img.src = img.dataset.src;
      delete img.dataset.src;
    }
    if (img.dataset.srcset) {
      img.srcset = img.dataset.srcset;
      delete img.dataset.srcset;
    }
    img.classList.add('loaded');
  };

  // ── Reveal logic (video) ──────────────────────────────
  const revealVideo = (video) => {
    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      delete source.dataset.src;
    });
    if (video.dataset.src) {
      video.src = video.dataset.src;
      delete video.dataset.src;
    }
    video.load();
    video.classList.add('loaded');
  };

  const reveal = (el) => {
    if (el.classList.contains('loaded')) return;
    if (el.tagName === 'VIDEO') revealVideo(el);
    else revealImage(el);
  };

  // ── Ek j shared IntersectionObserver (2 alag alag ni jagya e - overhead ochu) ──
  const hasIO = 'IntersectionObserver' in window;
  const lazyObserver = hasIO
    ? new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          reveal(entry.target);
        });
      }, { rootMargin: ROOT_MARGIN, threshold: 0 })
    : null;

  // ── :has() selector nathi vaparyu (jyare unsupported hoy tyare crash thay chhe) ──
  // ── source[data-src] ne closest('video') thi resolve kariye chhiye ──
  const collectTargets = (root) => {
    const targets = new Set();

    const consider = (el) => {
      if (el.tagName === 'IMG' && el.hasAttribute('data-src')) targets.add(el);
      if (el.tagName === 'VIDEO' && el.hasAttribute('data-src')) targets.add(el);
      if (el.tagName === 'SOURCE' && el.hasAttribute('data-src')) {
        const video = el.closest('video');
        if (video) targets.add(video);
      }
    };

    if (root.nodeType === 1 && root.matches?.(SELECTOR)) consider(root);
    root.querySelectorAll?.(SELECTOR).forEach(consider);

    return targets;
  };

  const observe = (el) => {
    if (el.classList.contains('loaded')) return;
    if (lazyObserver) {
      lazyObserver.observe(el);
    } else {
      // IntersectionObserver support nathi -> graceful fallback: tarat j load
      reveal(el);
    }
  };

  // ── MutationObserver: naya nodes ne requestAnimationFrame ma batch kari process ──
  // (infinite-scroll jevi rapid mutations ma repeated querySelectorAll na thay)
  const pendingRoots = new Set();
  let rafScheduled = false;

  const flushPending = () => {
    rafScheduled = false;
    const roots = [...pendingRoots];
    pendingRoots.clear();
    roots.forEach((root) => collectTargets(root).forEach(observe));
  };

  const scheduleFlush = () => {
    if (rafScheduled) return;
    rafScheduled = true;
    (window.requestAnimationFrame || setTimeout)(flushPending);
  };

  const mutationObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        pendingRoots.add(node);
      });
    }
    if (pendingRoots.size) scheduleFlush();
  });

  // ── Init ──────────────────────────────────────────────
  const init = () => {
    collectTargets(document).forEach(observe);
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  };

  // Fix: script defer/async thi DOMContentLoaded pachhi load thay to event kadi na fire thay
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    console.log(event.target.name,"event.target.nameevent.target.nameevent.target.name")
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('ajax-cart-quantity', QuantityInput);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);

    // 🔥 fallback (important)
    setTimeout(() => {
      if (!this.classList.contains('product-recommendations--loaded')) {
        console.log('fallback trigger');
        this.loadRecommendations(this.dataset.productId);
      }
    }, 500);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;

          // build swiper markup from grid__items injected by Shopify
          const items = this.querySelectorAll('.swiper-slide');
          const swiperEl = this.querySelector('.swiper');
          
          console.log(items.length,"items.lengthitems.lengthitems.length")
          if (swiperEl && items.length) {
            // wrap each item in swiper-slide
            const wrapper = swiperEl.querySelector('.swiper-wrapper');

            
            // get section id from data attr
            const sectionId = this.dataset.sectionId;
            
            console.log(swiperEl,"swiperElswiperElswiperElswiperEl")
            new Swiper(swiperEl, {
              loop: false,
              spaceBetween: 15,
              navigation: {
                prevEl: `.rec-prev-${sectionId}`,
                nextEl: `.rec-next-${sectionId}`,
              },
              pagination: {
                el: `.rec-pagination-${sectionId}`,
                clickable: true,
              },
              breakpoints: {
                0:   { slidesPerView: 2, pagination: { enabled: true  } },
                768: { slidesPerView: 3, pagination: { enabled: false } },
                992: { slidesPerView: 4, pagination: { enabled: false } },
              },
              on: {
                init: function() {
                  initMobileSlider();
                  initProductCardHover();
                }
              }
            });
          }
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }
        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => console.error(e));
  }
}
customElements.define('product-recommendations', ProductRecommendations);

function initProductCardHover() {
  document.querySelectorAll('.product-card').forEach(card => {
    const video = card.querySelector('.video-media');
    if (!video) return;

    let isLoaded = false;

    card.addEventListener('mouseenter', () => {
      if (!isLoaded) {
        video.setAttribute('preload', 'auto');
        video.load();
        isLoaded = true;
      }

      video.play().catch(() => {});
    });

    card.addEventListener('mouseleave', () => {
      video.pause();
      video.currentTime = 0;
    });
  });
}


function initMobileSlider() {
  // console.log('inn  3332122');
  if (window.innerWidth > 992) return;

  // console.log('inn  2122');
  document.querySelectorAll('.product-card-media__slider').forEach(slider => {
    if (slider.classList.contains('swiper-initialized')) return;

    const swiper = new Swiper(slider, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      allowTouchMove: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    // autoplay videos
    slider.querySelectorAll('video').forEach(video => {
      video.play().catch(() => {});
    });
  });
}
window.addEventListener('load', () => {
  // console.log('innn');
  setTimeout(initMobileSlider, 200);
  initProductCardHover();
});
// document.addEventListener('DOMContentLoaded', initMobileSlider);
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    initMobileSlider();
  }, 250);
});


// $(function () {
//   $(document).on('click', '[data-faq-btn]', function () {
//     const $faqItem = $(this).closest('[data-faq-item]');
//     const $faqAnswer = $faqItem.find('[data-faq-content]');

//     const isActive = $faqItem.hasClass('active');

//     $('[data-faq-item]').removeClass('active');
//     $('[data-faq-content]').stop(true, true).slideUp();

//     if (!isActive) {
//       $faqItem.addClass('active');
//       $faqAnswer.stop(true, true).slideDown();
//     }
//   });
// });

// Accordion 
$(function () {
  $(document).on('click', '[data-faq-btn]', function () {

    const $faqWrapper = $(this).closest('.faq-accordian-wrapper'); 
    const $faqItem = $(this).closest('[data-faq-item]');
    const $faqAnswer = $faqItem.find('[data-faq-content]');

    const isActive = $faqItem.hasClass('active');

    if ($faqWrapper.hasClass('multiple-accordion')) {
      
      if (isActive) {
        $faqItem.removeClass('active');
        $faqAnswer.stop(true, true).slideUp();
      } else {
        $faqItem.addClass('active');
        $faqAnswer.stop(true, true).slideDown();
      }

    } else {
      $faqWrapper.find('[data-faq-item]').not($faqItem).removeClass('active');
      $faqWrapper.find('[data-faq-content]').not($faqAnswer).stop(true, true).slideUp();

      if (!isActive) {
        $faqItem.addClass('active');
        $faqAnswer.stop(true, true).slideDown();
      } else {
        $faqItem.removeClass('active');
        $faqAnswer.stop(true, true).slideUp();
      }
    }
  });
});

// Hero slideshow 

// var swiper = new Swiper('.mySwiper', {
//   loop: true,
//   autoHeight: true,
//   autoplay: {
//     delay: 7000,
//     disableOnInteraction: false,
//   },
//   pagination: {
//     el: '.swiper-pagination',
//   },
// });

document.querySelectorAll(".slide-show .mySwiper").forEach((slider) => {
  new Swiper(slider, {
    loop: false,
    slidesPerGroup: 1,
    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
    },
    pagination: {
      el: slider.querySelector(".swiper-pagination"),
      clickable: true,
    },
    slidesPerView: "auto",
  });
});


// custom-review slider 

var reviewSwiper = new Swiper('.tp-slider.swiper', {
  slidesToScroll: 1,
  slidesPerView: 1,
  navigation: {
    nextEl: '.swiper-button-next-custom',
    prevEl: '.swiper-button-prev-custom',
  },
  breakpoints: {
    1200: {
      slidesPerView: 4,
    },
    991: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 2,
    },
    540: {
      slidesPerView: 1,
    }
  }
});



// Story slider 
const mainSwiper = new Swiper('.story-right-content', {
  slidesPerView: 3,
  spaceBetween: 20,
  speed: 600,
  grabCursor: true,
  breakpoints: {
    0: { slidesPerView: 1.2, spaceBetween: 10 },
    575: { slidesPerView: 2, spaceBetween: 10 },
    768: { slidesPerView: 2.5 },
    1200: { slidesPerView: 3 }
  }
});

// INNER SLIDERS (images)
document.querySelectorAll('.story-card-inner').forEach((el) => {
  new Swiper(el, {
    slidesPerView: 1,
    nested: true, 
    pagination: {
      el: el.querySelector('.inner-pagination'),
      clickable: true
    },
    navigation: {
      nextEl: el.querySelector('.swiper-button-next'),
      prevEl: el.querySelector('.swiper-button-prev'),
    },
  });
});


// Main step popup 
document.querySelectorAll('.swiper.jt-popup-content').forEach((el) => {
  const nextBtn = document.getElementById('hwNext');

  const swiper = new Swiper(el, {
    slidesPerView: 1,
    allowTouchMove: true, 
    pagination: {
      el: el.querySelector('.swiper-pagination'),
      clickable: true
    }
  });

  nextBtn.addEventListener('click', function () {
    const isLast = swiper.activeIndex === swiper.slides.length - 1;

    if (isLast) {
      document.getElementById('jtPopup').classList.remove('active');
      document.body.style.overflow = '';
    } else {
      swiper.slideNext();
    }
  });

  swiper.on('slideChange', function () {
    const isLast = this.activeIndex === this.slides.length - 1;
    nextBtn.textContent = isLast ? "Let's start" : "Next";
  });
});


// Custom-design page steps popup hide show 
// document.body.style.overflow = 'hidden';
document.getElementById('hwSkip')?.addEventListener('click', function(){
    document.getElementById('jtPopup').classList.remove('active');
    document.body.style.overflow = '';
});



// Shopify Chat Button 
const interval = setInterval(() => {
  const el = document.querySelector('#ShopifyChat');

  if (!el || !el.shadowRoot) return;
  clearInterval(interval);
  const shadow = el.shadowRoot; // use existing shadow root

  const style = document.createElement('style');
  style.textContent = `
    @media screen and (max-width: 768px) {
      button.chat-toggle {
        height: 43px;
        margin: 0;
        width: 43px;
      }
      button.chat-toggle.chat-toggle--icon-button.icon-only svg,
      button.chat-toggle.chat-toggle--icon-button.mobile-only svg {
        height: 40px;
      }
    }
  `;

  shadow.appendChild(style);

}, 500);



// Custom image with text video height 
function syncHeight() {
  if (window.innerWidth < 990) {
    document.querySelectorAll('.item-media-wrapper').forEach(el => {
      el.style.height = '';
    });
    return;
  }

  document.querySelectorAll('.custom-image-with-text .inner-content .section-1, .custom-image-with-text .inner-content .section-2').forEach(section => {
    const content = section.querySelector('.content');
    const media = section.querySelector('.item-media-wrapper');

    if (!content || !media) return;

    media.style.height = 'auto';
    media.style.height = content.offsetHeight + 'px';
  });
}

syncHeight();
window.addEventListener('load', syncHeight);
window.addEventListener('resize', syncHeight);
setTimeout(syncHeight, 500);





function updateHeaderHeight() {
  const announcementBar = document.querySelector('#shopify-section-announcement');
  const header = document.querySelector('header');

  const headerHeight = header ? header.offsetHeight : 0;
  const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;

  const totalHeight = headerHeight + announcementHeight;

  document.documentElement.style.setProperty('--visible-header', totalHeight + 'px');
}

updateHeaderHeight();
window.addEventListener('resize', updateHeaderHeight);



// search close button

document.querySelectorAll('.main-search-bar-wrapper').forEach(wrapper => {

  const searchInput = wrapper.querySelector('.input-search');
  const preSearch = wrapper.querySelector('.pre-search-main-wrapper');
  const clearSearch = wrapper.querySelector('.icon-close');

  let delayTimeout;

  searchInput.addEventListener('input', () => {
    if (searchInput.value.trim() === '') {
      preSearch.classList.remove('hidden');
      clearSearch.classList.add('hidden');
    } else {
      clearSearch.classList.remove('hidden');

      clearTimeout(delayTimeout);
      delayTimeout = setTimeout(() => {
        preSearch.classList.add('hidden');
      },500);
    }
  });

  wrapper.querySelectorAll(".pre-search-keys li").forEach(li => {
    li.addEventListener("click", () => {
      searchInput.value = li.textContent.trim();
      searchInput.focus();
      searchInput.dispatchEvent(new Event('input'));
    });
  });

  clearSearch.addEventListener('click', () => {
    searchInput.value = '';
    searchInput.focus();
    clearSearch.classList.add('hidden');
    preSearch.classList.remove('hidden');
    wrapper.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    searchInput.dispatchEvent(new Event('input'));
  });

});



// Ring Size Converter 
function ringSizeConverter(section) {
  const dropdown = section.querySelector('.ring-size-converter .country-selector');
  const trigger = dropdown.querySelector('[data-dropdown-trigger]');
  const hiddenInput = dropdown.querySelector('input[type="hidden"]');

  const diameterSelect = section.querySelector('#insideDiameter');
  const ringSizeSelect = section.querySelector('#ringSize');
  const resultBox = section.querySelector('[data-ring-size-result]');
  const findBtn = section.querySelector('.find-btn');

  trigger.addEventListener('click', (e) => {
    e.stopPropagation();
    dropdown.classList.toggle('active');
  });

  document.addEventListener('click', (e) => {
    if (!dropdown.contains(e.target)) {
      dropdown.classList.remove('active');
    }
  });

  dropdown.querySelectorAll('.dropdown-item').forEach((item) => {
    item.addEventListener('click', (e) => {
      e.preventDefault();

      const country = item.dataset.country;

      hiddenInput.value = country;

      trigger.querySelector('.selected-country-content').innerHTML = item.innerHTML;

      dropdown.classList.remove('active');

      diameterSelect.value = '';
      ringSizeSelect.value = '';
      diameterSelect.disabled = false;
      ringSizeSelect.disabled = false;

      //resultBox.innerHTML = `<span>3.50</span>&nbsp;`;

      ringSizeSelect.querySelectorAll('option').forEach((option) => {
        if (!option.dataset.country) return;

        option.hidden = option.dataset.country !== country;
      });
    });
  });

  diameterSelect.addEventListener('change', () => {
    ringSizeSelect.disabled = diameterSelect.value;
  });

  ringSizeSelect.addEventListener('change', () => {
    diameterSelect.disabled = ringSizeSelect.value;
  });


  findBtn.addEventListener('click', () => {
    let option;

    if (diameterSelect.value) {
      option = diameterSelect.options[diameterSelect.selectedIndex];
    }

    if (ringSizeSelect.value) {
      option = ringSizeSelect.options[ringSizeSelect.selectedIndex];
    }

    if (!option) return;
    const selectedSize = option.dataset.size;
    resultBox.innerHTML = `
    <span>${selectedSize} US</span>
    `;

    const buttons = document.querySelectorAll('.custom-button-group .custom-btn');
    let isMatched = false;
    buttons.forEach((btn) => {
      const matchId = btn.dataset.matchId;

      // hide all first
      btn.classList.add('hidden');

      // matched button
      if (matchId == selectedSize) {
        btn.classList.remove('hidden');
        isMatched = true;
      }
    });

    // if no match found show fallback button
    if (!isMatched) {
      const defaultBtn = document.querySelector(
        '.custom-button-group .custom-btn[data-match-id="0"]'
      );

      if (defaultBtn) {
        defaultBtn.classList.remove('hidden');
      }
    }

  });
}

document.querySelectorAll('.ring-size-converter').forEach((section) => {
  ringSizeConverter(section);
});


// Main product offer text copy 

document.querySelectorAll(".offer-block-right").forEach((button) => {
  button.addEventListener("click", () => {
  const text = button.querySelector("span").textContent;
  navigator.clipboard.writeText(text);
  const span = button.querySelector("span");
    span.textContent = "Copied!";

    setTimeout(() => {
      span.textContent = text;
    }, 2000);

  });
});

// Offer Blocks slider 

var offerSlider = new Swiper('.offer-slider', {
 slidesPerView: 1.3,
    spaceBetween: 10,
    loop: false,
    grabCursor: true,
    autoplay: {
    delay: 2500,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  speed: 800,
   breakpoints: {
      576: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1201: {
        slidesPerView: 2,
      }
    }
});


// // Collection on scroll none sort option 

const stickyEl = $('.tc-filter-wrap')[0];
const sortWrap = $('.filter-wrap.sort-by');

if(stickyEl) {
  $(window).on('scroll', function () {
  
    const stickyTop = parseInt(getComputedStyle(stickyEl).top);
  
    if (stickyEl.getBoundingClientRect().top <= stickyTop) {
      sortWrap.addClass('d-none');
    } else {
      sortWrap.removeClass('d-none');
    }
  
  });
}


function autoClickShowMore() {
  const interval = setInterval(() => {
    // Show more button find karo
    const btn = document.querySelector(
      'button[aria-label="Show more reviews"]'
    );

    // Button hoy ane visible hoy to click karo
    if (btn && btn.offsetParent !== null) {
      btn.click();
      console.log("Show more clicked");
    } else {
      // Button na male etle stop kari do
      clearInterval(interval);
      console.log("No more Show more button");
    }

    // Read more button hoy to auto click karo
    const readMoreBtns = document.querySelectorAll(
      'button[aria-label="Show more reviews"]'
    );

    readMoreBtns.forEach((el) => {
      if (
        el.innerText &&
        el.innerText.toLowerCase().includes("read more")
      ) {
        el.click();
        console.log("Read more clicked");
      }
    });

  }, 2000); // 2 second pachi check
}

// Function call
autoClickShowMore();

// Product Size Accordion
document.addEventListener('DOMContentLoaded', function () {
  // Accordion
  $(document).on('click', '.product-personalization-block .personalization-header', function () {

    const $accItem = $(this).closest('.product-personalization-block');
    const $accAnswer = $accItem.find('.personalization-content');

    $accItem.toggleClass('active');
    $accAnswer.stop(true, true).slideToggle(300);

  });

  // Character Counter
  const textareaFields = document.querySelectorAll('.personalization-input');
  textareaFields.forEach((textarea) => {
    textarea.addEventListener('input', function () {
      const currentCount = this.value.length;
      this.closest('.personalization-input-wrapper')
        .querySelector('.current-count')
        .innerText = currentCount;
    });
  });
});


// Product Page media zoom

function productImageZoom() {
  let zoom = false;

  $(document)
  .on('click.productZoom', '.product-details-in .left.product-media-popup .product-main-slider img', function(e){
    if (window.innerWidth > 1200) return;

    zoom = !zoom;
    $(this).css({
      transform: zoom ? 'scale(2)' : 'scale(1)',
      cursor: zoom ? 'zoom-out' : 'zoom-in',
      transformOrigin:
        ((e.offsetX / $(this).width()) * 100) + '% ' +
        ((e.offsetY / $(this).height()) * 100) + '%'
    });
  })

  .on('mousemove.productZoom', '.product-details-in .left.product-media-popup .product-main-slider img', function(e){
    if (window.innerWidth > 1200 || !zoom) return;

    $(this).css(
      'transform-origin',
      ((e.offsetX / $(this).width()) * 100) + '% ' +
      ((e.offsetY / $(this).height()) * 100) + '%'
    );
  });

  $(window).on('resize.productZoomReset', function() {
    if (window.innerWidth > 1200 && zoom) {
      zoom = false;
      $('.product-details-in .left.product-media-popup .product-main-slider img').css({
        transform: 'scale(1)',
        cursor: 'zoom-in'
      });
    }
  });
}

productImageZoom();

// Size Guide Popup
(function(){
  var overlay = document.getElementById('sgOverlay');
  var closeBtn = document.getElementById('sgClose');

  function openPopup() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
  }
  function closePopup() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
  }

  // All triggers: data attr or class
  document.querySelectorAll('[data-size-guide-trigger], .size-guide-trigger').forEach(function(el){
    el.addEventListener('click', openPopup);
  });

  closeBtn?.addEventListener('click', closePopup);

  overlay?.addEventListener('click', function(e){
    if(e.target === overlay) closePopup();
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') closePopup();
  });

  // document.addEventListener('click', function(e) {
  //   const trigger = e.target.closest('.chat-trigger');
  //   if (!trigger) return;
  //   e.preventDefault();
  //   closePopup();
  //   // const shadowHost = document.querySelector('inbox-online-store-chat');
  //   // if (!shadowHost || !shadowHost.shadowRoot) return;
  //   // const chatButton = shadowHost.shadowRoot.querySelector(
  //   //   '[data-spec="toggle-button"]'
  //   // );
  //   // if (chatButton) {
  //   //   chatButton.click();
  //   // }
  //   const shopifyChat = document.querySelector('shopify-chat');
  //   if (shopifyChat?.shadowRoot) {
  //     const runtime = shopifyChat.shadowRoot.querySelector('shopify-agent-runtime');

  //     if (runtime?.shadowRoot) {
  //       const activatorBtn = runtime.shadowRoot.querySelector('.activator');
  //       activatorBtn?.click();
  //     }
  //   }
  // });

  document.addEventListener('click', function (e) {
      const btn = e.target.closest('.sg-block__btn.chat-trigger');
      if (!btn) return;

      e.preventDefault();
      closePopup();

      function waitForChatWidget() {
          const shadowHost = document.querySelector('shopify-chat[view="chat"]');

          if (!shadowHost || !shadowHost.shadowRoot) {
              setTimeout(waitForChatWidget, 500);
              return;
          }

          let chatToggle = shadowHost.shadowRoot.querySelector(
              'button.activator'
          );

          if (!chatToggle) {
              const agentRuntime = shadowHost.shadowRoot.querySelector(
                  'shopify-agent-runtime'
              );

              if (agentRuntime && agentRuntime.shadowRoot) {
                  chatToggle = agentRuntime.shadowRoot.querySelector(
                      'button.activator'
                  );
              }
          }

          console.log('chatToggle:', chatToggle);

          if (chatToggle) {
              chatToggle.click();
          } else {
              console.log('Chat toggle not found. Retrying...');
              setTimeout(waitForChatWidget, 500);
          }
      }

      waitForChatWidget();
  });
})();


// Wishlist Icon 
function initWishlist() {
  const wishlistBlock = document.querySelector(
    '.section-main-product .wishlistflow-app-block-container'
  );

  const cartButton = document.querySelector(
    '.section-main-product .cart-button'
  );

  if (wishlistBlock && cartButton && !cartButton.contains(wishlistBlock)) {
    cartButton.appendChild(wishlistBlock);
  }
}

function moveWishlistIcon() {
  const icon = document.querySelector('.wishlist-flow-header-icon');
  const mobileWrapper = document.querySelector('.wishlist-flow-header-icon-mobile');
  const desktopWrapper = document.querySelector('.wishlist-flow-header-icon-desktop'); 

  if (!icon || !mobileWrapper || !desktopWrapper) return;

  if (window.innerWidth < 1200) {
    if (!mobileWrapper.contains(icon)) {
      mobileWrapper.appendChild(icon);
    }
  } else {
    if (!desktopWrapper.contains(icon)) {
      desktopWrapper.appendChild(icon);
    }
  }
}

initWishlist();
moveWishlistIcon();
const headerWishlistObserver = new MutationObserver(() => {
  initWishlist();
  moveWishlistIcon();
});
headerWishlistObserver.observe(document.body, {
  childList: true,
  subtree: true
});
window.addEventListener('resize', initWishlist);
window.addEventListener('resize', moveWishlistIcon);


// change css page(app) track order
const poweredByElement = document.getElementById('track123-powered-by');

if (poweredByElement) {
  poweredByElement.style.setProperty('color', '#ffffff', 'important');
  poweredByElement.style.setProperty('opacity', '1', 'important');
}

// function equalIconTextHeight() {
//   const items = document.querySelectorAll('.jewelry-care-guide .icon-and-text-item');
//   if (!items.length) return;
//   items.forEach(item => {
//     item.style.height = 'auto';
//   });
//   let maxHeight = 0;
//   items.forEach(item => {
//     maxHeight = Math.max(maxHeight, item.offsetHeight);
//   });
//   items.forEach(item => {
//     item.style.height = `${maxHeight}px`;
//   });
// }
// window.addEventListener('load', equalIconTextHeight);
// let boxResizeTimer;
// window.addEventListener('resize', () => {
//   clearTimeout(boxResizeTimer);
//   boxResizeTimer = setTimeout(equalIconTextHeight, 150);
// });


document.addEventListener("DOMContentLoaded", () => {
  if (!document.body.classList.contains("template-collection")) return;

  const addShopifyAgentStyles = () => {
    const shopifyAgent = document.querySelector('shopify-agent[view="chat"]');
    if (!shopifyAgent || !shopifyAgent.shadowRoot) return false;
    if (shopifyAgent.shadowRoot.querySelector("#custom-collection-mobile-style")) {
      return true;
    }

    const style = document.createElement("style");
    style.id = "custom-collection-mobile-style";
    style.textContent = `
      @media screen and (max-width: 991px) {
        .activator-nudge {
          bottom: 60px !important;
        }
      }
    `;
    shopifyAgent.shadowRoot.appendChild(style);
    return true;
  };

  if (addShopifyAgentStyles()) return;

  const chatBoxObserver = new MutationObserver(() => {
    if (addShopifyAgentStyles()) {
      chatBoxObserver.disconnect();
    }
  });

  chatBoxObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});

document.addEventListener("DOMContentLoaded", (event) => {
  let removeTimer;
  let allowHover = true;
  const $logo = $('.logo-stick');
  const $logo_center = $('.header-in .center');
  const $trigger = $('.has-mega-menu');
  const header = document.querySelector('header');
  const care_guide = document.querySelector('.care-guide');
  const care_bar = document.querySelector('.care-guide .cg-cats');
  const faq = document.querySelector('.faq-page');
  const faq_bar = document.querySelector('.faq-category-wrapper');
  const mainHeader = document.querySelector('#shopify-section-new-header');
  const announcementBar = document.querySelector('#shopify-section-announcement');
  const bodyElement = document.body;

  let lastScroll = 0;

  const headerHeight = header?.offsetHeight || 0;
  const announcementHeight = announcementBar?.offsetHeight || 0;

  function handleScroll() {
    const searchBar = document.querySelector(".search-bar");

    //code-1 start
    const timer = document.querySelector('.custom-timer');
    const stickyHeader = document.querySelector('#shopify-section-new-header');
    const collectionFilter = document.querySelector('.template-collection .tc-filter-wrap.tc-filter-wrap__header');
    //code-1 end

    if (searchBar?.classList.contains("active")) {
      mainHeader?.classList.add("stickey-header");
      bodyElement?.classList.add("stickey-header");
      header.classList.add("backdrop");
      return;
    }

    const scroll = window.scrollY;
    const limit = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercentage = (scroll / limit) * 100;

    let visibleHeader = 0;

    if (scroll <= announcementHeight) {
      visibleHeader = headerHeight + (announcementHeight - scroll);
    } else {
      const scrolledAfterAnnouncement = scroll - announcementHeight;
      visibleHeader = Math.max(headerHeight - scrolledAfterAnnouncement, 0);
    }

    const delta = scroll - lastScroll;
    if (Math.abs(delta) < 1) return;

    const isScrollingUp = delta < 0;

    if (isScrollingUp && scrollPercentage > 1) {
      visibleHeader = header.offsetHeight;
      header.classList.add('backdrop');
      mainHeader?.classList.add('stickey-header');
      bodyElement?.classList.add('stickey-header');
      //code-2 start
      const timerHeight = timer && getComputedStyle(timer).display !== 'none' ? timer.getBoundingClientRect().height : 0;
      const stickyHeaderHeight = stickyHeader && getComputedStyle(stickyHeader).display !== 'none' ? stickyHeader.getBoundingClientRect().height : 0;
      
      if (stickyHeader) {
        stickyHeader.style.setProperty('top', `${timerHeight}px`, 'important');
      }
      if (collectionFilter) {
        collectionFilter.style.setProperty('top', `${timerHeight + stickyHeaderHeight}px`, 'important');
      }
      //code-2 end
    } else {
      header.classList.remove('backdrop');
      mainHeader?.classList.remove('stickey-header');
      bodyElement?.classList.remove('stickey-header');
      //code-3 strat
      if (stickyHeader) {
        stickyHeader.style.removeProperty('top');
      }

      if (collectionFilter) {
        const timerHeight = timer && getComputedStyle(timer).display !== 'none' ? timer.getBoundingClientRect().height : 0;
        collectionFilter.style.setProperty('top', `${timerHeight}px`, 'important');
      }
      //code-3 end
    }

    document.documentElement.style.setProperty('--visible-header', visibleHeader + 'px');

    if (care_guide && care_bar) {
      const barRect = care_bar.getBoundingClientRect();
      const isVisible = barRect.top < window.innerHeight && barRect.bottom > 0;

      if (scrollPercentage > 15 && isVisible) {
        care_bar.style.transform = isScrollingUp ? 'translateY(62px)' : 'translateY(0%)';
      } else {
        care_bar.style.transform = 'translateY(0px)';
      }

      care_bar.classList.toggle('backdrop', scrollPercentage > 15 && isVisible);
    }

    if (faq && faq_bar) {
      const barRect = faq_bar.getBoundingClientRect();
      const isVisible = barRect.top < window.innerHeight && barRect.bottom > 0;

      if (scrollPercentage > 5 && isVisible) {
        faq_bar.style.transform = isScrollingUp ? 'translateY(62px)' : 'translateY(0%)';
      } else {
        faq_bar.style.transform = 'translateY(0px)';
      }

      faq_bar.classList.toggle('backdrop', scrollPercentage > 10 && isVisible);
    }

    lastScroll = scroll;
  }


  window.addEventListener('scroll', handleScroll, { passive: true });

  //code-4 start
  (function () {
    function updateProductHeaderTop() {
      const timer = document.querySelector('.custom-timer');
      const stickyHeader = document.querySelector(
        '.template-product #shopify-section-new-header'
      );

      if (!stickyHeader) return;

      if (!timer || getComputedStyle(timer).display === 'none') {
        stickyHeader.style.setProperty('top', '0px', 'important');
        return;
      }
      stickyHeader.style.setProperty(
        'top',
        timer.offsetHeight + 'px',
        'important'
      );
    }

    updateProductHeaderTop();

    window.addEventListener('scroll', updateProductHeaderTop);
    window.addEventListener('resize', updateProductHeaderTop);
  })();
  //code-4 end


  $trigger.hover(function() {
    if (!allowHover) return;
    clearTimeout(removeTimer);
    $logo.addClass('mega-menu-open');
    $logo_center.addClass('mega-menu-open');
  }, function() {
    if (!allowHover) return;
    removeTimer = setTimeout(() => {
      $logo.removeClass('mega-menu-open');
      $logo_center.removeClass('mega-menu-open');
      document.documentElement.classList.remove("overflow-hidden");
    }, 300);
  });

  $(document).on("click", ".cart_close", function() {
    $(".my-cart").removeClass("active");
    $("body").removeClass("js-show-ajax-cart");
    $(".cart-backdrop").removeClass("active");
    document.documentElement.classList.remove("overflow-hidden");
  });

  $(document).on("click", ".cart-backdrop", function() {
    $(".my-cart").removeClass("active");
    $("body").removeClass("js-show-ajax-cart");
    $(".cart-backdrop").removeClass("active");
    document.documentElement.classList.remove("overflow-hidden");
  });



  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          initializeAnimation(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );

  const target_banner = document.querySelectorAll(".letter-animation-banner");
  const targets = document.querySelectorAll(".letter-animation");

  if (target_banner.length) {
    setTimeout(() => {
      target_banner.forEach((target) => observer.observe(target));
    }, 3500);
  }

  if (targets.length) {
    targets.forEach((target) => observer.observe(target));
  }


  document.querySelectorAll(".header-icons-wrap .search, .mobile_header .search")
    .forEach(btn => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const searchBar = document.querySelector(".search-bar");
        searchBar.classList.toggle("active");
        document.body.classList.toggle(
          "overflow-hidden",
          searchBar.classList.contains("active")
        );
      });
    });

  document.addEventListener("keyup", (e) => {
    if (e.key === "Escape") {
      document.querySelector(".search-bar")?.classList.remove("active");
      document.body.classList.remove("overflow-hidden");
    }
  });

});

function setHeaderHeight() {
  var announce = document.querySelector('.announce-wrapper');
  if (announce) {
    document.documentElement.style.setProperty('--announce-height', announce.offsetHeight + 'px');
  }
  var header = document.querySelector('header');
  if (header) {
    document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
  }
}

setHeaderHeight();
window.addEventListener('resize', setHeaderHeight);

const scrollBtn = document.querySelector(".to-top-button");
if (scrollBtn) {
  scrollBtn.style.display = window.scrollY > 300 ? "flex" : "none";

  window.addEventListener("scroll", () => {
    scrollBtn.style.display = window.scrollY > 300 ? "flex" : "none";
  });

  scrollBtn.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
}

const videos = document.querySelectorAll(".prod-main video");
if (videos) {
  const videoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    },
    { threshold: 0.6 }
  );

  videos.forEach((video) => {
    video.muted = true;
    video.playsInline = true;
    videoObserver.observe(video);
  });
}

document.addEventListener('wheel', function(e) {
  const modal = document.querySelector('.media-popup .popup-right');
  if (!modal) return;
  if (modal.contains(e.target)) {
    e.stopImmediatePropagation();
  }
}, true);

(function () {
  function initInstagramPopup() {
    const popup = document.querySelector('.insta-popup');
    const items = document.querySelectorAll('.insta-grid__item');
    const closeBtn = document.querySelector('.insta-popup .insta-close');
    const overlayBtn = document.querySelector('.insta-popup .insta-popup-overlay');

    if (!popup || items.length === 0) return;

    const innerSwipers = new Swiper('.insta-inner-slider', {
      slidesPerView: 1,
      loop: document.querySelectorAll('.insta-inner-slider .swiper-slide').length > 1,
      on: {
        touchStart: function () {
          mainSwiper.allowTouchMove = false;
        },
        touchEnd: function () {
          mainSwiper.allowTouchMove = true;
        }
      },
      watchOverflow: true,
      nested: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    const mainSwiper = new Swiper('.insta-main-slider', {
      slidesPerView: 1,
      loop: true,
      effect: 'fade',
      allowTouchMove: true,
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: '.main-swiper-next',
        prevEl: '.main-swiper-prev',
      },
    });

    items.forEach(item => {
      item.addEventListener('click', function () {
        const index = parseInt(this.getAttribute('data-index'));

        popup.classList.add('active');
        document.body.classList.add('overflow-hidden');

        mainSwiper.slideTo(index, 0);

        setTimeout(() => {
          mainSwiper.update();
          if (Array.isArray(innerSwipers)) {
            innerSwipers.forEach(s => s.update());
          } else if (innerSwipers) {
            innerSwipers.update();
          }
        }, 10);
      });
    });

    const closePopup = () => {
      popup.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    };

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (overlayBtn) overlayBtn.addEventListener('click', closePopup);
  }

  document.addEventListener('DOMContentLoaded', initInstagramPopup);
})();

// Shoppay custom trigger
document.addEventListener("click", (event) => {
  const customTrigger = event.target.closest(
    "#shopify-installments-trigger"
  );

  if (!customTrigger) return;
  const installmentPrice = customTrigger.dataset.price;
  const shopifyPaymentTerms = document.querySelector(
    "shopify-payment-terms"
  );

  if (!shopifyPaymentTerms?.shadowRoot) return;
  const originalInstallmentButton =
    shopifyPaymentTerms.shadowRoot.querySelector(
      "#shopify-installments-cta"
    );

  if (!originalInstallmentButton) return;

  originalInstallmentButton.dispatchEvent(
    new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
      composed: true
    })
  );

  const updatePopupPrice = setInterval(() => {
    const popupHost = document.querySelector(
      '[data-nametag="shop-portal-provider"]'
    );
    if (!popupHost?.shadowRoot) return;
    const popupSubtitle = popupHost.shadowRoot.querySelector(
      '[data-testid="split-pay-subtitle"]'
    );
    if (!popupSubtitle) return;
    const popupPrices = popupSubtitle.querySelectorAll(
      ".font-bold"
    );
    const popupInstallmentPrice =
      popupPrices[popupPrices.length - 1];
    if (!popupInstallmentPrice) return;
    popupInstallmentPrice.innerHTML = installmentPrice;
    clearInterval(updatePopupPrice);
  }, 100);

  setTimeout(() => {
    clearInterval(updatePopupPrice);
  }, 5000);
});

document.querySelectorAll("shopify-payment-terms").forEach((el) => {
  const shadow = el.shadowRoot;
  if (!shadow) return;

  const style = document.createElement("style");
  style.textContent = `
    #shopify-installments p {
      font-size: 15px !important;
      line-height: 1;
    }
  `;
  shadow.appendChild(style);
});

// Chat button css
function fixNudge(root) {
  if (root.querySelector('#nudge-fix-style')) return;

  const isCollection = document.body.classList.contains('template-collection');
  const isMobile = window.innerWidth <= 991;

  const bottom = (isCollection && isMobile) ? '68px' : '38px';

  const style = document.createElement('style');
  style.id = 'nudge-fix-style';
  style.textContent = `
    .activator-nudge {
      bottom: ${bottom} !important;
    }

    @media screen and (max-width: 1300px) {
      .activator-nudge {
        bottom: 25px !important;
      }
    }
  `;

  root.appendChild(style);
  
}

function findAndFix() {
  const host = document.querySelector('shopify-chat');
  if (!host || !host.shadowRoot) return false;

  fixNudge(host.shadowRoot);

  const runtime = host.shadowRoot.querySelector('shopify-agent-runtime');
  if (runtime && runtime.shadowRoot) {
    fixNudge(runtime.shadowRoot);
  }

  return true;
}

const chatObserver = new MutationObserver(() => {
  findAndFix();
});

chatObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

findAndFix();


// blog caption text copy
document.querySelectorAll('.orielle-copy-btn').forEach(function (button) {
  button.addEventListener('click', function () {
    const card = button.closest('.orielle-caption-card');
    const text = card.querySelector('.orielle-caption-text').textContent.trim();

    navigator.clipboard.writeText(text).then(function () {
      button.textContent = 'COPIED';

      setTimeout(function () {
        button.textContent = 'COPY';
      }, 1500);
    });
  });
});
